import { Injectable, ErrorHandler } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { ShowcaseDialogComponent } from "../../pages/modal-overlays/dialog/showcase-dialog/showcase-dialog.component";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ErrorHandlerService implements ErrorHandler {
  constructor(private dialogService: NbDialogService, private router: Router) {}

  handleError(error: any): void {
    console.error("Global Error:", error);
    if (
      error?.name === "TimeoutError" ||
      error?.status === 504 ||
      error?.status === 408 ||
      error?.status === 503
    ) {
      location.reload();
    } else if (error?.error?.message) {
      this.showDialog(error.error.message);
    } else if (error?.message) {
      this.showDialog(error.message);
    } else {
      this.showDialog(
        "Une erreur serveur est survenue. Veuillez rafraîchir la page."
      );
    }
  }

  private showDialog(message: string, title: string = "Erreur"): void {
    this.dialogService.open(ShowcaseDialogComponent, {
      context: {
        title,
        message,
        headerIcon: "fa-exclamation",
      },
    });
  }
}
